export default __webpack_public_path__ + "static/media/cif-mh.56120849.svg";